import { useEffect, useState, useRef } from 'react'
import {
  useLazyGetPlantDetailsByCodeQuery,
  useLazyGetPlantsQuery,
} from '../../api/app/PlantApiService'
import { PlantData, PlantInfo } from '../../interface/response/PlantResponse'
import {
  REQUEST_TAB_STATUS,
  Tabs,
  eventKeyToKeyMap,
} from '../../utils/constants/RequestCommonConstant'

const usePlantHooks = () => {
  const [getPlantList, plantList] = useLazyGetPlantsQuery()
  const [getPlantDetails, plantDetails] = useLazyGetPlantDetailsByCodeQuery()
  const [selectedPlant, setSelectedPlant] = useState<PlantData>()
  const [selectedPlantDetails, setSelectedPlantDetails] = useState<PlantInfo>()
  const [query, setQuery] = useState('')
  const [searchedInputValue, setSearchedInputValue] = useState('')
  const [filteredList, setFilteredList] = useState<PlantData[] | undefined>(
    plantList?.data as PlantData[] | undefined,
  )
  const [showPlantDetailsFormStatus, setShowPlantDetailsFormStatus] =
    useState<boolean>(false)
  const [selectedTab, setSelectedTab] = useState<string>(
    REQUEST_TAB_STATUS.PENDING.eventKey,
  )
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  const handleTabSelection = (key: string) => {
    setSelectedTab(key)
  }

  useEffect(() => {
    if (selectedTab) {
      const status: string = eventKeyToKeyMap[selectedTab].toString()
      getPlantList({ status: status })
      setSelectedPlant(undefined)
      setSelectedPlantDetails(undefined)
    }
  }, [selectedTab, getPlantList])

  const handlePlantSelection = (plantCode: string) => {
    const selectedPlant = plantList?.data?.filter(
      (item) => item.plantCode === plantCode,
    )[0]
    setSelectedPlant(selectedPlant)
  }
  useEffect(() => {
    const plantArray = plantList?.data ?? []
    if (plantArray?.length > 0 && !selectedPlant) {
      setSelectedPlant(plantArray[0])
    }
    // else {
    //   setSelectedPlant(undefined)
    //   setSelectedPlantDetails(undefined)
    // }
  }, [plantList?.data])

  useEffect(() => {
    const latestData = plantList?.data?.filter((item: PlantData) =>
      item?.plantName?.toLowerCase().includes(query?.toLowerCase()),
    )
    setFilteredList(latestData)
    if (!latestData || latestData?.length <= 0) {
      setSelectedPlant(undefined)
      setSelectedPlantDetails(undefined)
    }
  }, [query, plantList?.data])
  useEffect(() => {
    if (plantDetails?.data) {
      setSelectedPlantDetails(plantDetails?.data)
    } else {
      setSelectedPlantDetails(undefined)
    }
  }, [plantDetails?.data])
  useEffect(() => {
    if (selectedPlant) getPlantDetails(selectedPlant.plantCode)
    else {
      setSelectedPlantDetails(undefined)
    }
  }, [selectedPlant, getPlantDetails])

  const onSearchQueryHandler = (
    e: React.SyntheticEvent,
    selectedTab: string,
  ) => {
    const target = e.target as HTMLInputElement
    const searchQuery = target.value
    setSearchedInputValue(target.value)

    // Clear the previous timeout if there's any
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    // Set a new timeout to execute the search after 500ms
    timeoutRef.current = setTimeout(() => {
      setQuery(searchQuery)
      setSelectedTab(selectedTab)
    }, 500) // 500ms debounce time
  }

  const updateShowPlantDetailFormStatus = (status: boolean) => {
    setShowPlantDetailsFormStatus(status)
  }

  return {
    selectedTab,
    selectedPlant,
    plantList,
    selectedPlantDetails,
    filteredList,
    query,
    Tabs,
    searchedInputValue,
    showPlantDetailsFormStatus,
    onSearchQueryHandler,
    handlePlantSelection,
    updateShowPlantDetailFormStatus,
    handleTabSelection,
    setSelectedPlant,
  }
}

export default usePlantHooks
